module.exports = __webpack_public_path__ + "media/fonts/Oricons-d471c62aec5ca857b3aa8e3d3c4142a7.woff2";